import { Mail, MessageCircle, Phone, ShieldCheck } from 'lucide-react';
import { Card } from '@pixlide/ui';
import { SUPPORT_MAILTO } from '@/lib/support';

function ContactRow({
  icon,
  title,
  subtitle,
  href,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  href?: string;
}) {
  const className =
    'flex w-full items-center justify-between gap-3 rounded-input border border-ink-100 px-4 py-3 text-left transition hover:border-brand-200 hover:bg-brand-50/40';

  const content = (
    <div className="flex items-center gap-3">
      <span aria-hidden className="text-ink-500">
        {icon}
      </span>
      <div>
        <p className="text-sm font-semibold text-ink-900">{title}</p>
        <p className="text-xs text-ink-500">{subtitle}</p>
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} className={className}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={className}>
      {content}
    </button>
  );
}

/**
 * Encart « Besoin d'aide ? » : identique sur `SupportPage` et `MessagesPage`. Extrait ici
 * pour éviter la double maintenance des mêmes trois canaux de contact.
 */
export function HelpSidebar() {
  return (
    <Card className="flex flex-col gap-5 p-6 text-center">
      <div className="flex flex-col items-center gap-1">
        <h3 className="text-xl font-semibold text-ink-900">Besoin d'aide ?</h3>
        <p className="text-sm text-ink-500">
          Notre équipe d'assistance est là pour vous. Nous répondons généralement en quelques minutes.
        </p>
      </div>

      <div className="flex flex-col gap-3 text-left">
        <ContactRow
          icon={<MessageCircle className="size-5" strokeWidth={1.5} />}
          title="Discutez avec nous"
          subtitle="Obtenez de l'aide en temps réel"
        />
        <ContactRow
          icon={<Mail className="size-5" strokeWidth={1.5} />}
          title="Envoyez-nous un e-mail"
          subtitle="Nous reviendrons vers vous."
          href={SUPPORT_MAILTO}
        />
        <ContactRow
          icon={<Phone className="size-5" strokeWidth={1.5} />}
          title="Appelez-nous"
          subtitle="Lundi - Vendredi : 9h00 - 18h00"
        />
      </div>

      <p className="flex items-center justify-center gap-1.5 text-xs text-ink-400">
        <ShieldCheck aria-hidden className="size-3.5" />
        Toutes les conversations sont sécurisées et confidentielles.
      </p>
    </Card>
  );
}
